import { useContext } from "react";
import TextEditor from "../../components/Table/TextEditor";
import { context } from "../../context/authContext";
import useActions from "./acciones";

export default function useColumns(setSelectedRow,setModalOpen, roles, empresas) {
  const { user } = useContext(context);
  const { handleDelete } = useActions();

  const userRoles = user?.rol || [];
  const permisos = userRoles.find((role) => role.nombre === "Usuarios")?.permiso || [];
  const isEditable = permisos.includes("editar");
  const canDelete = permisos.includes("borrar");

  let roleOptions = {};
  let empresaOptions = {};
  for(const rol of roles){
    if(rol.nombre !== "superadmin"){
      roleOptions[rol.id] = rol.nombre;
    }
  }
  for(const empresa of empresas){
    empresaOptions[empresa.id] = empresa.nombre;
  }
  return [
    { field: "id", sort: "asc", cellClass: "d-flex align-items-center" },
    ...["nombre", "apellido", "dni", "email", "password","direccion","provincia","ciudad","cp","telefono"].map((field) => ({
      field,
      flex: field === "id" || field === "cp" ? 1 : field === "email" ? 3 : 2,
      cellClass: "d-flex align-items-center",
      cellEditor: TextEditor,
      editable: isEditable,
      valueFormatter: field === "password" ? () => "********" : undefined,
      tooltipValueGetter: (params) => params.data?.[`tooltipError${field}`] || "",
      cellClassRules: {
        "is-invalid": (params) => !!params.data?.[`tooltipError${field}`],
        "is-valid": (params) => !!params.data?.[`isValid${field}`],
      },
    })),
    {
      field: "rol",
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellEditor: "agSelectCellEditor",
      editable: (params) => params.data.rol !== "superadmin" && isEditable,
      cellEditorParams: { values: Object.keys(roleOptions) },
      valueFormatter: (params) => roleOptions[params.value] || params.value,
    },
    {
      field: "empresa",
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellEditor: "agSelectCellEditor",
      editable: (params) => params.data.rol !== "superadmin" && isEditable,
      cellEditorParams: { values: Object.keys(empresaOptions) },
      valueFormatter: (params) => empresaOptions[params.value] || params.value,
    },
    // { field: "empresa", flex: 2, cellClass: "d-flex align-items-center", cellEditor: TextEditor, editable: false },
    canDelete && {
      field: "eliminar",
      flex: 2,
      cellClass: "d-flex align-items-center justify-content-center",
      cellRenderer: (data) => (
        <button onClick={() => handleDelete(data, setSelectedRow,setModalOpen)} className="btn btn-primary px-2 py-1">
          🗑️ Eliminar
        </button>
      ),
    },
  ].filter(Boolean);
}
